import Vue from 'vue'
import cart from './cart'

const store = Vue.observable({
  cart: cart
})

export default store
